import { render } from "./blog-tags.vue?vue&type=template&id=72502911"
import script from "./blog-tags.vue?vue&type=script&lang=js"
export * from "./blog-tags.vue?vue&type=script&lang=js"

import "./blog-tags.vue?vue&type=style&index=0&id=72502911&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__